import { Injectable } from '@angular/core';
import {
  EdytujUstawieniaAplikacjiMobilnychRequest,
  UstawieniaAplikacjiMobilnejDto,
} from '@interfaces/administracja/systems/ustawienia-aplikacji-mobilnej.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UstawieniaAplikacjiMobilnychService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/systems/ustawienia-aplikacji-mobilnych`;

  getUstawienia(): Observable<UstawieniaAplikacjiMobilnejDto> {
    return this.http.get<UstawieniaAplikacjiMobilnejDto>(this.endpoint);
  }

  zmienUstawienia(data: EdytujUstawieniaAplikacjiMobilnychRequest): Observable<null> {
    return this.http.put<null>(this.endpoint, data);
  }
}
